import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const Label = styled.div`
  flex: 1;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  color: rgba(0, 0, 0, 0.87);
`;
